import { PaletteMode } from "@mui/material";

export interface SevaGradientConfig {
  background: string;
  foreground: string;
  muted: string;
  panelBackground: string;
  panelBorder: string;
  accentShadow: string;
}

const SEVA_GRADIENT: Record<"light" | "dark", SevaGradientConfig> = {
  light: {
    background: "linear-gradient(135deg, #0A4A9E 0%, #0D6FDB 100%)",
    foreground: "#FFFFFF",
    muted: "rgba(255, 255, 255, 0.82)",
    panelBackground: "rgba(255, 255, 255, 0.22)",
    panelBorder: "rgba(255, 255, 255, 0.38)",
    accentShadow: "0 18px 32px rgba(13, 109, 219, 0.32)",
  },
  dark: {
    background: "linear-gradient(135deg, rgba(84, 140, 215, 0.92) 0%, rgba(48, 95, 180, 0.88) 100%)",
    foreground: "rgba(237, 244, 255, 0.95)",
    muted: "rgba(237, 244, 255, 0.76)",
    panelBackground: "rgba(18, 32, 65, 0.55)",
    panelBorder: "rgba(237, 244, 255, 0.28)",
    accentShadow: "0 16px 30px rgba(12, 48, 108, 0.35)",
  },
};

export function getSevaGradientConfig(mode: PaletteMode = "light"): SevaGradientConfig {
  return SEVA_GRADIENT[mode === "dark" ? "dark" : "light"];
}

export function getSevaGradientSurface(
  theme: { palette: { mode: PaletteMode } },
  options: { withShadow?: boolean } = {},
) {
  const config = getSevaGradientConfig(theme.palette.mode);
  return {
    ...config,
    color: config.foreground,
    boxShadow: options.withShadow ? config.accentShadow : undefined,
  } as const;
}
